module.exports = __webpack_public_path__ + "media/St 4-desk lamp-correct.e2d01bf1.wav";